import { Outlet } from 'react-router';
import { Box } from '@mui/material';
import { useAppContext } from '~/AppProviders';
import Header from '../components/Header.jsx';
import AppLoader from '~/components/AppLoader.jsx';

function RouterRootComponent() {
  const { accountName, isRealmLoading, realmName } = useAppContext();
  const isWorkspaceReady = Boolean(accountName && realmName);

  if (isRealmLoading || !isWorkspaceReady) {
    return <AppLoader />;
  }

  return (
    <Box className="root-layout">
      <Header />
      <Box
        component="main"
        className="root-main">
        <Outlet />
      </Box>
    </Box>
  );
}

export default RouterRootComponent;
